export const marketResearchStatus = {
  TODO: "TODO",
  IN_PROGRESS: "IN_PROGRESS",
  DONE: "DONE",
  FAILED: "FAILED",
  TIMED_OUT: "TIMED_OUT",
  INSUFFICIENT_INFORMATION: "INSUFFICIENT_INFORMATION",
  INSUFFICIENT_INFORMATION_COMPANY_WEBSITE:
    "INSUFFICIENT_INFORMATION_COMPANY_WEBSITE",
  INSUFFICIENT_INFORMATION_ASSOCIATED_COMPANY:
    "INSUFFICIENT_INFORMATION_ASSOCIATED_COMPANY",
  INSUFFICIENT_INFORMATION_LEAD_NAME: "INSUFFICIENT_INFORMATION_LEAD_NAME",
  INSUFFICIENT_INFORMATION_CONTACT_NAME:
    "INSUFFICIENT_INFORMATION_CONTACT_NAME",
  INSUFFICIENT_CREDITS: "INSUFFICIENT_CREDITS",
};
